export default "__VITE_ASSET__3gGxEP5u__"